import { useMemo, useState, useContext, useRef, useEffect } from 'react';

import { Image } from 'antd';

import Utils from '../../utils/Utils';

import { LoadingImg } from './components/picturePerview';
import TotalPrice from './components/totalPrice';

import { secondKillValidatePerfect } from '@lcsc-ui/apis/so';
import Colon from '@lcsc-ui/components/Colon';
import InputSelect from '@lcsc-ui/components/InputSelect';
import LabelText from '@lcsc-ui/components/LabelText';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { ProductItemContext } from '@lcsc-ui/providers/productItem';
import { ProductListContext } from '@lcsc-ui/providers/productList';
import { goItemBuriedPoint } from '@lcsc-ui/utils/buriedPoint';

function SecondKillItem(props) {
  const { isMro, productVO, secondKillProductVO } = props;

  const { resourceData, onlySScreen } = useContext(LayoutContext);
  const { searchResult, track_zone } = useContext(ProductListContext);
  const { index, rs_log, newParameterCondition } = useContext(ProductItemContext);
  const [purchaseCount, setPurchaseCount] = useState(null);
  const [loading, setLoading] = useState();
  const [currentTime, setCurrentTime] = useState(null);
  const inputSelectRef = useRef(null);
  const addBtnRef = useRef(null);
  const timer = useRef(null);

  useEffect(() => {
    timer.current = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => {
      timer.current && clearInterval(timer.current);
    };
  }, []);

  const leftTime = useMemo(() => {
    if (!currentTime) {
      return;
    }
    if (!secondKillProductVO?.validEndTime) {
      timer.current && clearInterval(timer.current);
      return <></>;
    }
    let during = new Date(secondKillProductVO?.validEndTime) - currentTime;
    if (during <= 0) {
      timer.current && clearInterval(timer.current);
      return (
        <div>
          <span className="flex items-center">
            剩余
            <Colon />
          </span>
          <span className="text-[14px] font-bold text-[#FF6B10]">00</span>天
          <span className="text-[14px] font-bold text-[#FF6B10]">00</span>小时
          <span className="text-[14px] font-bold text-[#FF6B10]">00</span>分
          <span className="text-[14px] font-bold text-[#FF6B10]">00</span>秒
          <i className="ml-[5px] inline-block h-[20px] w-[22px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/so/ms-icon.png)]"></i>
        </div>
      );
    }
    during = during > 0 ? during / 1000 : 0;
    const days = Math.floor(during / (60 * 60 * 24));
    const hours = Math.floor((during % (60 * 60 * 24)) / (60 * 60))
      .toString()
      .padStart(2, '0');
    const minutes = Math.floor((during % (60 * 60)) / 60)
      .toString()
      .padStart(2, '0');
    const seconds = Math.floor(during % 60)
      .toString()
      .padStart(2, '0');
    return (
      <div className="flex items-center">
        <span>
          剩余
          <Colon />
        </span>
        <span className="text-[14px] font-bold text-[#FF6B10]">{days}</span>天
        <span className="text-[14px] font-bold text-[#FF6B10]">{hours}</span>
        小时
        <span className="text-[14px] font-bold text-[#FF6B10]">{minutes}</span>分
        <span className="text-[14px] font-bold text-[#FF6B10]">{seconds}</span>秒
        <i className="ml-[5px] inline-block h-[20px] w-[22px] bg-[url(https://static.szlcsc.com/ecp/assets/newWeb/so/ms-icon.png)]"></i>
      </div>
    );
  }, [currentTime, secondKillProductVO?.validEndTime]);

  const totalPrices = useMemo(() => {
    return Math.round(purchaseCount * secondKillProductVO?.secondKillPrice * 100) / 100;
  }, [purchaseCount, secondKillProductVO]);

  function gotoBuy() {
    if (!inputSelectRef?.current?.validate(purchaseCount)) {
      return;
    }
    if (loading) {
      return;
    }
    setLoading(true);
    secondKillValidatePerfect({
      activityId: secondKillProductVO?.secondKillActivityId,
      productId: secondKillProductVO?.productId,
      purchaseNumber: purchaseCount,
    })
      .then((res) => {
        if (res?.needLogin || res?.msg === 'needLogin') {
          Utils.showWindowLogin();
        } else if (res?.code === 200) {
          let url = `${resourceData?.projectConfigVO?.lcscOrderUrl}/member/perfect/ms.html?activityId=${secondKillProductVO?.secondKillActivityId}&productId=${secondKillProductVO?.productId}&purchaseNumber=${purchaseCount}`;
          if (track_zone) {
            url += `&trackZone=${Utils.safeEncodeURI(track_zone)}`;
          }
          url = Utils.getBtnSpmQueryUrl(url, addBtnRef.current);
          window.open(url, '_blank');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  // 跳转详情链接
  const detailPage = useMemo(() => {
    if (isMro) {
      return `${resourceData?.projectConfigVO?.lcscItemUrl}/mro/${productVO.productId}.html?fromZone=${Utils.safeEncodeURI(track_zone)}`;
    }
    return `${resourceData?.projectConfigVO?.lcscItemUrl}/${productVO.productId}.html?fromZone=${Utils.safeEncodeURI(track_zone)}`;
  }, [resourceData, isMro, productVO, track_zone]);

  // 产品数量单位
  const productUnitDom = useMemo(() => {
    return (
      productVO?.productMinEncapsulationUnit && (
        <p className="mb-[6px]">
          {productVO?.productMinEncapsulationNumber}
          {productVO?.productUnit}/{productVO.productMinEncapsulationUnit}
        </p>
      )
    );
  }, [productVO]);

  // 剩余库存
  const remainingInventory = useMemo(() => {
    return Utils.unitConversion(secondKillProductVO?.productTotalNumber - secondKillProductVO?.productOccupyNumber);
  }, [secondKillProductVO]);

  function gotoItem(kind) {
    goItemBuriedPoint({
      kind,
      pc: productVO?.productId,
      brand: productVO?.productGradePlateName,
      model: productVO?.productModel,
      code: productVO?.productCode,
      kw: searchResult?.globalSearchKeyword,
      cp: searchResult?.currePage,
      ix: index,
      track_zone: track_zone,
      rs_log,
      parameter_condition: newParameterCondition,
    });
  }

  return (
    <div className={`flex p-[20px] leading-[18px]`}>
      <div className="flex">
        <div className="w-[121px] h-[105px] select-none">
          <a
            data-spm="t"
            className="relative"
            aria-label="点击跳转详情"
            href={detailPage}
            target="_blank"
            onClick={() => gotoItem('picture')}
          >
            <div
              className="absolute z-[1] flex h-[20px] w-[40px] items-center rounded-[4px_0_10px_0] text-[white]"
              style={{
                background: 'linear-gradient(180deg, #FFA040 0%, #FF7C0B 100%)',
              }}
            >
              <span className="pl-[8px] leading-[15px] text-[white]">秒杀</span>
            </div>
            <Image
              fallback={'https://static.szlcsc.com/ecp/assets/web/static/images/default_pic.gif'}
              src={'https://static.szlcsc.com/ecp/assets/newWeb/so/lcms.svg'}
              width={105}
              height={105}
              preview={false}
              loading="lazy"
              placeholder={<LoadingImg></LoadingImg>}
              style={{ borderRadius: '4px' }}
              alt={'秒杀'}
            />
          </a>
        </div>
        <div className={Utils.addBigScreenClassName('w-[178px]', '_lg:w-[215px]', onlySScreen)}>
          <LabelText
            text={productVO?.productModel}
            title={productVO?.productModel}
            isTitle
            textBold
            link={detailPage}
            bp="型号"
            onClick={() => gotoItem('name')}
          ></LabelText>
          <LabelText
            label="品牌"
            text={productVO?.productGradePlateName}
            title={productVO?.productGradePlateName}
          ></LabelText>
          <LabelText
            label="封装"
            text={productVO?.encapsulationModel}
            title={productVO?.encapsulationModel}
          ></LabelText>
        </div>
        <div className={Utils.addBigScreenClassName('w-[190px]', '_lg:w-[233px]', onlySScreen)}>
          <div className="mb-[6px] text-[12px] leading-[16px] text-[#69788a]">{leftTime}</div>
          {secondKillProductVO?.outerRemark && (
            <LabelText label="备注" text={secondKillProductVO?.outerRemark}></LabelText>
          )}
          {secondKillProductVO?.productBatch && (
            <LabelText label="批次" text={secondKillProductVO?.productBatch}></LabelText>
          )}
        </div>
      </div>
      <div className={Utils.addBigScreenClassName('w-[157px]', '_lg:w-[180px]', onlySScreen)}></div>
      <div className="flex flex-1 justify-center">
        <ul className="w-[170px]">
          <li className="flex text-[#333]">
            <label className="w-[70px] text-right">
              {secondKillProductVO?.minPurchaseNumber}+<Colon />
            </label>
            <span className="flex-1 text-left">￥{Utils.priceRound(secondKillProductVO?.secondKillPrice, 6)}</span>
          </li>
        </ul>
      </div>
      <div className={Utils.addBigScreenClassName('w-[161px]', '_lg:w-[186px]', onlySScreen)}>
        <label className="mb-[6px] inline-block h-[18px] rounded-[3px] bg-[#EDEDED] px-[7px] leading-[18px] text-[#666]">
          结束后{secondKillProductVO?.productDeliveryDay - 1}-{secondKillProductVO?.productDeliveryDay + 1}工作日
        </label>
        <LabelText label="库存" text={remainingInventory} textBold></LabelText>
        {secondKillProductVO?.maxPurchaseNumber && (
          <LabelText label="限购" text={secondKillProductVO?.maxPurchaseNumber}></LabelText>
        )}
        {productUnitDom}
      </div>
      <div className={`${Utils.addBigScreenClassName('w-[120px]', '_lg:w-[140px]', onlySScreen)} text-right`}>
        <InputSelect
          ref={inputSelectRef}
          defaultCount={secondKillProductVO?.minPurchaseNumber}
          defaultUnit={productVO?.productUnit}
          productUnit={productVO?.productUnit}
          productMinEncapsulationUnit={productVO?.productMinEncapsulationUnit}
          productMinEncapsulationNumber={productVO?.productMinEncapsulationNumber}
          minBuyNumber={secondKillProductVO?.minPurchaseNumber}
          theRatio={secondKillProductVO?.theRatio}
          disabled={productVO?.productUnsealVendition === 'no'}
          stockNumber={remainingInventory}
          onChange={(value) => setPurchaseCount(value)}
        ></InputSelect>
        <TotalPrice totalPrices={totalPrices}></TotalPrice>
        {secondKillProductVO?.productTotalNumber - secondKillProductVO?.productOccupyNumber > 0 ? (
          <button
            ref={addBtnRef}
            data-spm="ms"
            className="mb-[6px] block h-[32px] w-full rounded-[6px] border-[1px] border-solid border-[#FF6B10] bg-[#FFF3E0] text-[14px] text-[#FF6B10]
            hover:border-[#FF6B10] hover:bg-[#FF6B10] hover:text-[white]"
            onClick={gotoBuy}
          >
            秒杀
          </button>
        ) : (
          <button className="mb-[6px] block h-[32px] w-full cursor-not-allowed rounded-[6px] bg-[#BABABA] p-[0] text-[14px] text-[white]">
            售罄
          </button>
        )}
      </div>
    </div>
  );
}

export default SecondKillItem;
